import { updateUser } from "@/zustand/user";
import axios from "axios";
import { JWT_KEY } from "../constants";

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_BASE_API_URL,
  timeout: 15000,
  headers: {
    "ngrok-skip-browser-warning": "69420",
    "x-client-platform": "web",
  },
});

axiosInstance.interceptors.request.use((config) => {
  const accessToken = localStorage.getItem(JWT_KEY);
  if (accessToken) {
    config.headers.authorization = `Bearer ${accessToken}`;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    if (axios.isAxiosError(err) && err.status === 401) {
      updateUser({ isLogin: false });
    }
    return Promise.reject(err);
  },
);

export default axiosInstance;
